import { Box, Grid, styled, Typography } from "@mui/material";
import { safeFormatDate } from "../../../utils/utilityFunctions";
import { PDFLink } from "../../styled/PDFLink";

const BorderBox = styled(Box)(({theme}) => ({
    paddingBottom: '0.3em',
    marginBottom: '0.5em',
    borderBottom: '1px solid #e1e2e3',
}));

export default function IcpInspectionNetworkApproval({title='', workOrderId, icpNumber, workOrderDetails}) {

    const customerNameList = [
        workOrderDetails?.workOrder?.customerContact?.firstName || '',
        workOrderDetails?.workOrder?.customerContact?.lastName || '',
    ]
    const phaseObj = workOrderDetails?.workOrder?.networkApprovedParameters?.phase // E.g. {red: true, white: false, blue: false}
    let phaseList = [] // We want e.g. ["red", "white"]
    if (phaseObj) {
        phaseList = Object.entries(phaseObj)
            .map(([phaseColor, isRequired]) => isRequired ? phaseColor : null)
            .filter((phaseColor) => phaseColor !== null)
    }

    const rcr = workOrderDetails?.workOrder?.networkApprovedParameters?.rippleControllerRequired
    const rippleControllerRequiredLabel = (rcr === true ? 'Yes' : (rcr === false ? 'No' : ''))
    return (
        <Box>
            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <PDFLink href={workOrderDetails?.workOrder?.networkApprovalFormURL} spinner={!workOrderDetails} label="Network Approval" target="_blank" rel="noreferrer" />
                </Grid>

                <Grid item xs={12} md={6}>
                    <ApprovalHeader header="Applicant Details" />
                        <LabelledItem label="Name" item={customerNameList.join(' ')} />
                        <LabelledItem  sx={{wordBreak: 'break-all'}} label="Email" item={workOrderDetails?.workOrder?.customerContact?.email} />
                        <LabelledItem label="Phone" item={workOrderDetails?.workOrder?.customerContact?.primaryPhone} />
                        <LabelledItem label="Alt Phone" item={workOrderDetails?.workOrder?.customerContact?.secondaryPhone} />
                        <LabelledItem label="Billing Address" item="--" />
                        <LabelledItem label="Preferred Contact" item="--" />

                    <ApprovalHeader header="Billing Details" />
                        <LabelledItem label="" item="--" />

                    <ApprovalHeader header="Retailer Account Holder" />
                        <LabelledItem label="" item="--" />

                    <ApprovalHeader header="Location Details" />
                        <LabelledItem label="ICP" item={workOrderDetails?.workOrder?.icpNo} />
                        <LabelledItem label="Street Address" item={workOrderDetails?.workOrder?.streetAddress} />
                        <LabelledItem label="Premise Type" item={workOrderDetails?.workOrder?.premiseType} />
                        <LabelledItem label="Dairy Number" item={workOrderDetails?.workOrder?.location?.dairyNumber} />
                        <LabelledItem label="Lot / DP Number" item={workOrderDetails?.workOrder?.location?.appellation} />
                        <LabelledItem label="Location Notes" item={workOrderDetails?.workOrder?.location?.directions} />
                </Grid>

                <Grid item xs={12} md={6}>
                    <ApprovalHeader header="Electrician Contact" />
                        <LabelledItem label="Name"  item={workOrderDetails?.workOrder?.electricianContact?.name} />
                        <LabelledItem label="Phone" item={workOrderDetails?.workOrder?.electricianContact?.phone} />
                        <LabelledItem label="Email" item={workOrderDetails?.workOrder?.electricianContact?.email} />

                    <ApprovalHeader header="Site Contact" />
                        <LabelledItem label="Name"  item={workOrderDetails?.workOrder?.siteContact?.name} />
                        <LabelledItem label="Phone" item={workOrderDetails?.workOrder?.siteContact?.phone} />
                        <LabelledItem label="Email" item={workOrderDetails?.workOrder?.siteContact?.email} />

                    <ApprovalHeader header="Network Details" />
                        <LabelledItem label="DSub" item={workOrderDetails?.workOrder?.networkApprovedParameters?.dSub} />
                        <LabelledItem label="kVA & Phase" item={workOrderDetails?.workOrder?.networkApprovedParameters?.kVAPhase} />
                        <LabelledItem label="Active ICPs" item={workOrderDetails?.workOrder?.networkApprovedParameters?.activeICPs} />

                    <ApprovalHeader header="Connection Details" />
                        <LabelledItem label="Scheduled Date" item={safeFormatDate(workOrderDetails?.workOrder?.scheduledDate)} />
                        <LabelledItem label="Description" item={workOrderDetails?.workOrder?.description} />
                        <LabelledItem label="Approval Type" item={workOrderDetails?.workOrder?.networkApprovedParameters?.approvalType} />
                        <LabelledItem label="Approval Date" item={safeFormatDate(workOrderDetails?.workOrder?.networkApprovedParameters?.approvalDate)} />
                        <LabelledItem label="Phase" item={workOrderDetails?.workOrder?.networkApprovedParameters?.numPhases} />
                        <LabelledItem label="Phase Colour" item={phaseList.join(', ')} />
                        <LabelledItem label="Service Main" item={workOrderDetails?.workOrder?.networkApprovedParameters?.serviceMain} />
                        <LabelledItem label="Fuse Current Ratings" item={workOrderDetails?.workOrder?.networkApprovedParameters?.fuseRating} />
                        <LabelledItem label="Controlled Load Required" item={rippleControllerRequiredLabel} />
                        <LabelledItem label="Maximum Capacity (Amps)" item={workOrderDetails?.workOrder?.networkApprovedParameters?.maxCapacityAmps} />
                        <LabelledItem label="Maximum Demand (kW)" item={workOrderDetails?.workOrder?.networkApprovedParameters?.maxDemandkW} />
                        <LabelledItem label="Connection Point" item={workOrderDetails?.workOrder?.networkApprovedParameters?.connectionPoint} />
                        <LabelledItem label="Asset Number" item={workOrderDetails?.workOrder?.networkApprovedParameters?.assetNumber} />
                </Grid>

            </Grid>
        </Box>
    )
}


function LabelledItem({label='', item, hideIfBlank=true, ...props}) {
    if (hideIfBlank && !item) {
        return null
    }
    return (
        <BorderBox sx={{border: 'none'}} {...props}>
            <Typography variant="body2">{label.toString()}</Typography>
            <Typography variant="body1"><strong>{item.toString()}</strong></Typography>
        </BorderBox>
    )
}

function ApprovalHeader({header, ...props}) {
    if (!header) {
        return null
    }
    return (
        <BorderBox sx={{marginTop: '2em'}} {...props}>
            <Typography variant="h5" sx={{color: (theme) => theme.palette.secondary.main, fontWeight: 'normal'}}>{header.toString()}</Typography>
        </BorderBox>
    )
}